<template>
  <v-navigation-drawer
    ref="drawer"
    v-model="show"
    :width="isCollapsed ? 60 : navigation.width"
    color="transparent"
    absolute
    hide-overlay
    stateless
    style="z-index: 2; transition: width 0.3s ease;"
  >
    <v-card
      :style="{ borderRadius: '0px', height: isCollapsed ? 'auto' : '100%' }"
    >
      <v-toolbar
        color="primary"
        dark
        dense
      >
        <v-btn
          dark
          icon
          @click="cerrar"
        >
          <v-icon>{{ isCollapsed ? 'mdi-chevron-right' : 'mdi-chevron-left' }}</v-icon>
        </v-btn>
        <v-toolbar-title
          v-if="!isCollapsed"
        >
          Simulaciones
        </v-toolbar-title>
      </v-toolbar>

      <v-card-text
        v-show="!isCollapsed"
        class="pa-0"
      >
        <v-tabs
          v-model="tabActiva"
          background-color="primaryLight"
          dark
          slider-color="white"
        >
          <v-tab
            v-for="t in tabs"
            :key="t"
            ripple
          >
            {{ t }}
          </v-tab>
        </v-tabs>

        <v-container
          v-if="tabActiva === 0"
          class="pl-7 pb-0"
        >
          <v-row
            dense
          >
            <p
              class="text-h6 black--text d-flex align-center"
            >
              <v-icon
                class="mr-2 tipo-simulacion-icon"
              >
                mdi-earth
              </v-icon>
              Tipo de simulación
            </p>
          </v-row>

          <v-row
            class="pl-6 mt-0"
            dense
          >
            <v-col
              class="pt-0"
            >
              <div
                class="d-flex align-center tipo-simulacion-row"
              >
                <v-radio-group
                  v-model="tipoSimulacion"
                  row
                  class="my-0"
                >
                  <v-radio
                    label="Incendio"
                    value="INCENDIO"
                    color="primary"
                    class="mr-6"
                  />
                  <v-radio
                    label="Viento"
                    value="VIENTO"
                    color="primary"
                  />
                </v-radio-group>

                <v-menu
                  v-if="tabActiva === 0"
                  open-on-hover
                  offset-x
                  max-width="360"
                >
                  <template
                    #activator="{ on, attrs }"
                  >
                    <v-btn
                      icon
                      depressed
                      class="info-pill"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon>mdi-information-outline</v-icon>
                    </v-btn>
                  </template>

                  <v-card
                    class="pa-3 info-card"
                  >
                    <div
                      class="body-2"
                    >
                      La simulación se realizará suponiendo una
                      conservación del momento (masa y velocidad),
                      utilizando el modelo WindNinja, con una
                      extensión cuadrada de 5x5 km.
                    </div>
                  </v-card>
                </v-menu>
              </div>
            </v-col>
          </v-row>
        </v-container>

        <v-tabs-items
          v-model="tabActiva"
        >
          <v-tab-item
            v-if="!disabledByRol"
            key="NuevaSimulacion"
          >
            <v-card
              flat
              class="simulacion-card d-flex flex-column fill-height"
            >
              <v-card-text
                class="simulacion-body"
              >
                <v-form
                  v-model="isValid"
                >
                  <v-container>
                    <v-row
                      dense
                    >
                      <p
                        class="text-h6 black--text"
                      >
                        <v-icon>mdi-crosshairs-gps</v-icon>
                        Posicionamiento
                      </p>
                    </v-row>
                    <v-row
                      class="pl-6 mt-0"
                    >
                      <v-col
                        cols="12"
                        class="pt-0"
                      >
                        <v-tabs
                          v-model="tabActivaGraficos"
                          slider-color="primaryLight"
                          class="tabs-graficos"
                        >
                          <v-tab
                            v-for="t in tabsGraficos"
                            :key="t"
                            ripple
                          >
                            {{ t }}
                          </v-tab>
                          <v-tab-item
                            key="SeleccionManual"
                          >
                            <v-row
                              class="pa-6"
                            >
                              <v-chip-group
                                selected-class="text-deep-purple-accent-4"
                                mandatory
                              >
                                <v-chip
                                  v-for="item in esriButtons"
                                  :key="item.id"
                                  :disabled="downloadingMeteo"
                                  @click="initSketch(item.id)"
                                >
                                  {{ item.label }}
                                  <v-icon
                                    small
                                    class="pl-2"
                                  >
                                    {{
                                      item.icon
                                    }}
                                  </v-icon>
                                </v-chip>
                              </v-chip-group>
                            </v-row>
                          </v-tab-item>

                          <v-tab-item
                            key="Coordenadas"
                          >
                            <v-row
                              class="pa-4"
                            >
                              <v-col
                                sm="4"
                              >
                                <v-text-field
                                  v-model="latitud"
                                  v-mask="'##.#####'"
                                  label="Latitud"
                                  dense
                                  outlined
                                  prepend-icon="mdi-map-marker"
                                  hide-details
                                />
                              </v-col>

                              <v-col
                                sm="4"
                              >
                                <v-text-field
                                  v-model="longitud"
                                  v-mask="'-#.#####'"
                                  label="Longitud"
                                  dense
                                  outlined
                                  hide-details
                                />
                                <!-- TODO: en alguna ocasion el - no sera obligatorio -->
                              </v-col>
                              <v-col
                                sm="4"
                                align="right"
                              >
                                <v-chip
                                  color="success"
                                  :disabled="downloadingMeteo"
                                  @click="addPunto"
                                >
                                  Añadir
                                  <v-icon
                                    small
                                    class="pl-2"
                                  >
                                    mdi-plus
                                  </v-icon>
                                </v-chip>
                              </v-col>
                            </v-row>
                          </v-tab-item>

                          <v-tab-item
                            v-if="tipoSimulacion === 'INCENDIO'"
                            key="SubirArchivo"
                          >
                            <v-row
                              class="pa-4"
                              align="stretch"
                              justify="center"
                            >
                              <v-col>
                                <v-sheet
                                  :class="[
                                    'dropzone d-flex flex-column align-center justify-center text-center',
                                    { 'dropzone--active': dragActive && dropContext === 'simulacion' }
                                  ]"
                                  height="160"
                                  outlined
                                  rounded
                                  @click="openPicker('simulacion')"
                                  @dragover.prevent="onDragOver('simulacion', $event)"
                                  @dragleave.prevent="onDragLeave('simulacion')"
                                  @dragend.prevent="onDragLeave('simulacion')"
                                  @drop.prevent="onDrop('simulacion', $event)"
                                >
                                  <v-icon
                                    size="28"
                                    class="mb-2 grey--text text--darken-1"
                                  >
                                    mdi-file-upload-outline
                                  </v-icon>

                                  <div
                                    class="body-2 grey--text text--darken-1"
                                  >
                                    Arrastra aquí tu archivo
                                    <span
                                      class="font-weight-medium"
                                    >.zip</span> (SHP) o
                                    <span
                                      class="font-weight-medium"
                                    >.kml</span>
                                  </div>

                                  <div
                                    class="caption grey--text text--darken-1 mt-1"
                                  >
                                    o haz click para buscarlo
                                  </div>
                                </v-sheet>

                                <input
                                  ref="fileInputSimulacion"
                                  type="file"
                                  accept=".zip,.kml"
                                  style="display:none"
                                  @change="onFileChange('simulacion', $event)"
                                >
                              </v-col>
                            </v-row>
                          </v-tab-item>
                        </v-tabs>
                      </v-col>
                    </v-row>
                    <v-data-table
                      v-show="focos.length !== 0"
                      :headers="[
                        { text: 'Nombre', sortable: false },
                        { text: 'Tipo', sortable: false },
                        { text: 'Eliminar', sortable: false },
                      ]"
                      :items="focos"
                      hide-default-footer
                      disable-pagination
                    >
                      <template
                        #item="{ item }"
                      >
                        <tr>
                          <td
                            class="text-xs-left"
                            style="width:15rem"
                          >
                            <template
                              v-if="editableFocoId === item.id"
                            >
                              <v-text-field
                                v-model="item.nombre"
                                dense
                                single-line
                                hide-details
                                autofocus
                                @blur="editableFocoId = null"
                                @keyup.enter="editableFocoId = null"
                              />
                            </template>
                            <template
                              v-else
                            >
                              <span
                                style="cursor: pointer"
                                @click="editableFocoId = item.id"
                              >
                                {{ item.nombre || `Foco ${item.id + 1}` }}
                              </span>
                            </template>
                          </td>
                          <td
                            class="text-xs-left"
                          >
                            {{ item.tipo }}
                          </td>
                          <td>
                            <v-btn
                              icon
                              small
                              :disabled="downloadingMeteo"
                              @click="eliminarFoco(item)"
                            >
                              <v-icon
                                small
                                color="error"
                              >
                                esri-icon-trash
                              </v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>

                    <v-row
                      v-show="focos.length !== 0"
                      class="pt-2"
                      dense
                    >
                      <v-col
                        align="center"
                      >
                        <v-btn
                          rounded
                          small
                          :disabled="downloadingMeteo"
                          @click="eliminarAllFocos()"
                        >
                          <v-icon
                            small
                            color="error"
                          >
                            esri-icon-trash
                          </v-icon>
                          Eliminar todo
                        </v-btn>
                      </v-col>
                    </v-row>

                    <!-- <v-row>
                       <v-text-field v-model="geometria" prepend-icon="esri-icon-map-pin" readonly clearable label="Geometría" :rules="[rules.required]" required/>
                      <p>{{ textoGeometria }}</p>
                    </v-row> -->

                    <v-row
                      dense
                    >
                      <p
                        class="text-h6 black--text"
                      >
                        <v-icon>mdi-terrain</v-icon>
                        Nombre de la simulación
                      </p>
                    </v-row>
                    <v-row
                      class="pl-6"
                    >
                      <v-col
                        class="pt-0"
                      >
                        <v-text-field
                          v-model="nombreSimulacion"
                          label="Nombre"
                          class="pt-0"
                        />
                      </v-col>
                    </v-row>

                    <v-row
                      dense
                    >
                      <p
                        class="text-h6 black--text"
                      >
                        <v-icon>mdi-fire</v-icon>
                        Incendio asociado
                      </p>
                    </v-row>
                    <v-row
                      class="mt-0"
                    >
                      <v-col>
                        <v-autocomplete
                          v-model="incendioSeleccionado"
                          label="Incendio"
                          :items="incendios"
                          item-text="NOMBRE"
                          item-value="ID_INCENDIO"
                          return-object
                          outlined
                          dense
                          :menu-props="{ offsetY: true, top: false }"
                          class="pl-6"
                        />
                      </v-col>
                    </v-row>

                    <v-row
                      dense
                      class="mb-2"
                    >
                      <v-col
                        cols="12"
                      >
                        <p
                          class="text-h6 black--text d-flex align-center mb-0"
                        >
                          <v-icon
                            class="mr-2 tipo-simulacion-icon"
                          >
                            esri-icon-calendar
                          </v-icon>
                          Selección temporal
                        </p>
                      </v-col>
                    </v-row>

                    <v-row
                      dense
                      class="pl-6 mt-0"
                    >
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <vx-date-text-edit
                          v-model="fechaInicio"
                          label="Fecha de inicio"
                          required
                          :disabled="downloadingMeteo"
                        />
                      </v-col>
                    </v-row>

                    <v-row
                      dense
                      class="pl-6 mt-4"
                    >
                      <v-col
                        v-if="tipoSimulacion === 'INCENDIO'"
                        cols="4"
                      >
                        <v-slider
                          v-model="intervaloIndex"
                          :min="0"
                          :max="intervaloOptions.length - 1"
                          :step="1"
                          class="slider-iso mb-1"
                          color="#025f87"
                          track-color="#607d8b"
                          thumb-label="always"
                          show-ticks="always"
                          :tick-labels="intervaloOptions"
                          :disabled="downloadingMeteo"
                        >
                          <template
                            #thumb-label="{ value }"
                          >
                            {{ intervaloOptions[value] }}min
                          </template>
                        </v-slider>
                        <div
                          class="text-caption mt-1"
                        >
                          Intervalo isócronas
                        </div>
                      </v-col>

                      <v-col
                        cols="8"
                      >
                        <v-slider
                          v-model="numHoras"
                          min="1"
                          max="12"
                          step="1"
                          class="slider-duracion mb-1"
                          color="#025f87"
                          track-color="#607d8b"
                          thumb-label="always"
                          show-ticks="always"
                          :tick-labels="tickLabelsHoras"
                          :disabled="downloadingMeteo"
                        >
                          <template
                            #thumb-label="{ value }"
                          >
                            {{ value }}h
                          </template>
                        </v-slider>
                        <div
                          class="text-caption mt-1"
                        >
                          Duración de la simulación
                        </div>
                      </v-col>
                    </v-row>

                    <v-row
                      v-if="tipoSimulacion === 'VIENTO'"
                      dense
                      class="pl-6 mt-4"
                    >
                      <span>
                        Intervalo isócronas: <strong>{{ intervaloIndex }} minutos</strong>
                      </span>
                    </v-row>

                    <v-expansion-panels
                      v-model="panelAjustesAvanzados"
                      flat
                      class="mt-4 ajustes-avanzados"
                    >
                      <v-expansion-panel>
                        <v-expansion-panel-header
                          class="px-0 py-2"
                        >
                          <v-row
                            class="d-flex align-center"
                          >
                            <v-icon
                              class="mr-2"
                            >
                              mdi-cog-outline
                            </v-icon>
                            <span
                              class="text-h6 black--text"
                            >Ajustes avanzados</span>
                          </v-row>
                        </v-expansion-panel-header>

                        <v-expansion-panel-content
                          class="pt-2 pb-4"
                        >
                          <v-row
                            dense
                          >
                            <p
                              class="text-h6 black--text"
                            >
                              <v-icon>mdi-weather-partly-cloudy</v-icon>
                              Meteorología
                            </p>
                          </v-row>

                          <div>
                            <v-select
                              v-if="tipoSimulacion === 'INCENDIO'"
                              v-model="modeloSeleccionado"
                              class="flex-grow-1 selector-modelo"
                              label="Modelo"
                              :items="modelosMeteo"
                              :item-disabled="item => !item.DATE"
                              item-text="NAME"
                              item-value="ID"
                              return-object
                              outlined
                              density="comfortable"
                              :disabled="!geometria || downloadingMeteo"
                              :menu-props="{ offsetY: true, top: false }"
                            >
                              <template
                                #item="{ item, attrs, on }"
                              >
                                <v-list-item
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <v-list-item-content>
                                    <v-list-item-title
                                      class="font-weight-medium"
                                    >
                                      {{ item.NAME }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                      {{
                                        (item.DATE && String(item.DATE).trim().length > 0)
                                          ? `Actualizado (UTC) 00:00 ${item.DATE}`
                                          : 'No hay datos disponibles para la fecha seleccionada'
                                      }}
                                    </v-list-item-subtitle>
                                  </v-list-item-content>
                                </v-list-item>
                              </template>

                              <template
                                #selection="{ item }"
                              >
                                <div
                                  v-if="item"
                                  class="selector-modelo-text"
                                >
                                  <span>{{ item.NAME }}</span>
                                  <tr />
                                  <span
                                    class="caption grey--text text--darken-1"
                                  >
                                    Actualizado (UTC) 00:00 {{ item.DATE }}
                                  </span>
                                </div>
                              </template>
                            </v-select>

                            <div
                              v-else
                              class="pl-6 mt-4"
                            >
                              <span>
                                Modelo: <strong>{{ modeloSeleccionado ? modeloSeleccionado.NAME : '' }}</strong>
                              </span>
                            </div>

                            <v-data-table
                              :headers="tipoSimulacion === 'INCENDIO' ? meteoHeaders : meteoHeadersWind"
                              :items="meteoData"
                              :disabled="tipoSimulacion !== 'INCENDIO'"
                              hide-default-footer
                              disable-pagination
                            >
                              <template
                                #item="{ item }"
                              >
                                <tr>
                                  <td
                                    class="text-xs-left"
                                  >
                                    {{ item.VARIABLE }}
                                  </td>
                                  <td
                                    v-if="tipoSimulacion === 'INCENDIO'"
                                    class="text-center"
                                  >
                                    <v-checkbox
                                      v-model="item.CHECK"
                                      class="d-inline-flex"
                                      dense
                                      hide-details
                                    />
                                  </td>
                                  <td
                                    v-for="(n, i) in parseInt(numHoras + 2)"
                                    :key="i"
                                  >
                                    <v-edit-dialog
                                      :return-value.sync="item.VALORES[i]"
                                      lazy
                                    >
                                      {{ item.VALORES[i] }}
                                      <template
                                        #input
                                      >
                                        <v-text-field
                                          v-model="item.VALORES[i]"
                                          label="Editar"
                                          type="number"
                                          :rules="getMeteoRules(item.ID)"
                                          :disabled="downloadingMeteo || !geometria"
                                          @input="meteoCheck"
                                          @change="cambiarMeteoLinea(item, i)"
                                        />
                                      </template>
                                    </v-edit-dialog>
                                  </td>
                                </tr>
                              </template>
                            </v-data-table>
                            <v-btn
                              v-if="tipoSimulacion === 'INCENDIO'"
                              class="my-3"
                              :disabled="!useCustomMeteo"
                              @click="revertirCambiosMeteo"
                            >
                              <v-icon
                                left
                              >
                                mdi-arrow-u-left-top
                              </v-icon>
                              Revertir cambios
                            </v-btn>
                          </div>

                          <v-row
                            dense
                            class="mt-2"
                          >
                            <p
                              class="text-h6 black--text"
                            >
                              <v-icon
                                class="mr-2"
                              >
                                mdi-weather-windy
                              </v-icon>
                              Viento
                            </p>
                          </v-row>

                          <v-row
                            v-if="tipoSimulacion === 'INCENDIO'"
                            dense
                          >
                            <v-col
                              cols="12"
                              sm="4"
                              class="pl-6"
                            >
                              <v-checkbox
                                v-model="vientosLocales"
                                label="Activar vientos locales"
                                class="my-0"
                                color="primary"
                                hide-details
                                @change="onChangeVientosLocales"
                              />
                            </v-col>

                            <v-col
                              cols="12"
                              sm="8"
                            />
                          </v-row>

                          <v-row
                            v-else
                            dense
                            class="pl-6 mt-4"
                          >
                            <span>
                              Resolución: <strong>100m</strong>
                            </span>
                          </v-row>

                          <!-- <v-row
                            v-if="tipoSimulacion === 'INCENDIO'"
                            dense
                            class="mt-1"
                          >
                            <v-col
                              cols="12"
                              sm="4"
                              class="pl-6"
                            >
                              <v-checkbox
                                v-model="resolucionPersonalizada"
                                label="Resolución personalizada"
                                class="my-0"
                                color="primary"
                                hide-details
                                @change="onChangeResolucionPersonalizada"
                              />
                            </v-col>

                            <v-col
                              cols="12"
                              sm="8"
                              class="d-flex align-center pr-0"
                            >
                              <div
                                class="flex-grow-1 ml-sm-4"
                              >
                                <v-slider
                                  v-model="resolucionViento"
                                  :min="minResolucionViento"
                                  :max="maxResolucionViento"
                                  :step="stepResolucionViento"
                                  class="slider-viento mb-1"
                                  color="#025f87"
                                  track-color="#607d8b"
                                  thumb-label="always"
                                  show-ticks="always"
                                  :tick-labels="tickLabelsViento"
                                  :disabled="!resolucionPersonalizada"
                                >
                                  <template
                                    #thumb-label="{ value }"
                                  >
                                    {{ value }}m
                                  </template>
                                </v-slider>
                                <div
                                  class="text-caption mt-1"
                                >
                                  Resolución de vientos locales (m)
                                </div>
                              </div>
                            </v-col>
                          </v-row> -->

                          <v-row
                            v-if="tipoSimulacion === 'INCENDIO'"
                            dense
                          >
                            <p
                              class="text-h6 black--text"
                            >
                              <v-icon>mdi-fire-off</v-icon>
                              Modelos de combustible
                            </p>
                          </v-row>

                          <!-- Fuego de copas -->
                          <v-row
                            v-if="tipoSimulacion === 'INCENDIO'"
                            dense
                            class="pl-6 mb-3"
                          >
                            <v-col
                              cols="12"
                              class="py-0"
                            >
                              <v-checkbox
                                v-model="activarFuegoCopas"
                                class="my-0"
                                color="primary"
                                hide-details
                                label="Activar fuego de copas (características del dosel forestal)"
                              />
                            </v-col>
                          </v-row>

                          <v-row
                            v-if="tipoSimulacion === 'INCENDIO'"
                            dense
                            class="pl-14 mt-2 mb-3"
                          >
                            <v-col
                              cols="12"
                              sm="4"
                              class="py-0"
                            >
                              <v-text-field
                                v-model="humedadFoliar"
                                label="Humedad foliar (%)"
                                type="number"
                                dense
                                outlined
                                hide-details
                                :disabled="!activarFuegoCopas"
                              />
                            </v-col>

                            <v-col
                              cols="12"
                              sm="8"
                              class="py-0"
                            >
                              <v-select
                                v-model="fuegoCopasSelected"
                                :items="metodosFuegoCopas"
                                label="Método de simulación del fuego en copas"
                                dense
                                outlined
                                hide-details
                                :disabled="!activarFuegoCopas"
                              />
                            </v-col>
                          </v-row>

                          <v-row
                            v-if="tipoSimulacion === 'INCENDIO'"
                            class="pl-6 mt-3 mb-4"
                          >
                            <v-col
                              cols="12"
                              class="py-0"
                            >
                              <div
                                class="texto-editar-opcion"
                              >
                                <span
                                  class="text-caption"
                                >Modificar carga de modelos de combustible</span>
                                <span
                                  class="separador-opcion text-caption"
                                >|</span>
                                <v-btn
                                  text
                                  small
                                  color="primary"
                                  class="btn-link-editar"
                                  @click="onEditarCargaModelos"
                                >
                                  Editar
                                </v-btn>
                              </div>

                              <div
                                class="texto-editar-opcion"
                              >
                                <span
                                  class="text-caption"
                                >Modificar humedad de modelos de combustible</span>
                                <span
                                  class="separador-opcion text-caption"
                                >|</span>
                                <v-btn
                                  text
                                  small
                                  color="primary"
                                  class="btn-link-editar"
                                  :disabled="!geometria"
                                  @click="onEditarHumedadModelos"
                                >
                                  Editar
                                </v-btn>
                              </div>
                            </v-col>
                          </v-row>

                          <v-row
                            v-if="tipoSimulacion === 'INCENDIO'"
                            dense
                            class="pl-6 fila-modelos-combustible"
                          >
                            <v-col
                              cols="12"
                              sm="6"
                              class="py-0 d-flex align-center"
                            >
                              <v-select
                                v-model="modeloCombustible"
                                class="select-modelo"
                                label="Seleccionar modelo"
                                :items="combustibles"
                                item-text="MODELO"
                                item-value="MODELO"
                                return-object
                                outlined
                                dense
                                hide-details
                              />
                            </v-col>

                            <v-col
                              cols="12"
                              sm="6"
                              class="py-0"
                            >
                              <div
                                class="botones-modelos"
                              >
                                <v-btn
                                  rounded
                                  :disabled="!modeloCombustible"
                                  @click="initModeloCombustible('polygon')"
                                >
                                  DIBUJAR ÁREA
                                  <v-icon
                                    small
                                    class="pl-2"
                                  >
                                    esri-icon-polygon
                                  </v-icon>
                                </v-btn>
                              </div>
                            </v-col>
                          </v-row>

                          <v-row
                            v-if="tipoSimulacion === 'INCENDIO'"
                            class="pl-6 mt-2"
                          >
                            <v-col
                              cols="12"
                            >
                              <v-sheet
                                :class="[
                                  'dropzone d-flex flex-column align-center justify-center text-center',
                                  { 'dropzone--active': dragActive && dropContext === 'simulacion' }
                                ]"
                                height="100"
                                outlined
                                rounded
                                :disabled="!modeloCombustible"
                                @click="openPicker('combustible')"
                                @dragover.prevent="onDragOver('combustible', $event)"
                                @dragleave.prevent="onDragLeave('combustible')"
                                @dragend.prevent="onDragLeave('combustible')"
                                @drop.prevent="onDrop('combustible', $event)"
                              >
                                <v-icon
                                  size="28"
                                  class="mb-2 grey--text text--darken-1"
                                >
                                  mdi-file-upload-outline
                                </v-icon>

                                <div
                                  class="body-2 grey--text text--darken-1"
                                >
                                  Arrastra aquí tu archivo
                                  <span
                                    class="font-weight-medium"
                                  >.zip</span> (SHP) o
                                  <span
                                    class="font-weight-medium"
                                  >.kml</span>
                                </div>

                                <div
                                  class="caption grey--text text--darken-1 mt-1"
                                >
                                  o haz click para buscarlo
                                </div>
                              </v-sheet>

                              <input
                                ref="fileInputCombustible"
                                type="file"
                                accept=".zip,.kml"
                                style="display:none"
                                @change="onFileChange('combustible', $event)"
                              >
                            </v-col>
                          </v-row>

                          <v-data-table
                            v-if="tipoSimulacion === 'INCENDIO'"
                            v-show="areasDeCombustibles.length !== 0"
                            :headers="[
                              { text: 'Nombre', sortable: false },
                              { text: 'Numero de modelo', sortable: false },
                              { text: 'Eliminar', sortable: false },
                            ]"
                            :items="areasDeCombustibles"
                            hide-default-footer
                            disable-pagination
                          >
                            <template
                              #item="{ item }"
                            >
                              <tr>
                                <td
                                  class="text-xs-left"
                                >
                                  Area de combustible {{ item.id }}
                                </td>
                                <td>Modelo {{ item.modelo }}</td>
                                <td>
                                  <v-btn
                                    icon
                                    small
                                    @click="eliminarModeloCombustible(item)"
                                  >
                                    <v-icon
                                      small
                                      color="error"
                                    >
                                      esri-icon-trash
                                    </v-icon>
                                  </v-btn>
                                </td>
                              </tr>
                            </template>
                          </v-data-table>
                          <v-row
                            v-if="tipoSimulacion === 'INCENDIO'"
                            v-show="areasDeCombustibles.length !== 0"
                            class="pt-2"
                            dense
                          >
                            <v-col
                              align="center"
                            >
                              <v-btn
                                rounded
                                small
                                @click="eliminarAllModelosCombustible()"
                              >
                                <v-icon
                                  small
                                  color="error"
                                >
                                  esri-icon-trash
                                </v-icon>
                                Eliminar todo
                              </v-btn>
                            </v-col>
                          </v-row>

                          <v-row
                            v-if="tipoSimulacion === 'INCENDIO'"
                            dense
                            class="mt-5"
                          >
                            <p
                              class="text-h6 black--text"
                            >
                              <v-icon>mdi-fire-off</v-icon>
                              Añadir zonas no combustibles
                            </p>
                          </v-row>
                          <v-row
                            v-if="tipoSimulacion === 'INCENDIO'"
                            class="pl-6"
                            no-gutters
                          >
                            <v-col
                              class="d-flex flex-row flex-nowrap align-center"
                            >
                              <v-btn
                                class="mr-2"
                                rounded
                                size="x-large"
                                @click="initZonasNoCombustibles('polyline')"
                              >
                                CORTAFUEGOS
                                <v-icon
                                  small
                                  class="pl-2"
                                >
                                  esri-icon-polyline
                                </v-icon>
                              </v-btn>

                              <v-btn
                                rounded
                                size="x-large"
                                @click="initZonasNoCombustibles('polygon')"
                              >
                                ÁREA NO COMBUSTIBLE
                                <v-icon
                                  small
                                  class="pl-2"
                                >
                                  esri-icon-polygon
                                </v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>

                          <v-row
                            v-if="tipoSimulacion === 'INCENDIO'"
                            class="pl-6 mt-2"
                          >
                            <v-col
                              cols="12"
                            >
                              <v-sheet
                                :class="[
                                  'dropzone d-flex flex-column align-center justify-center text-center',
                                  { 'dropzone--active': dragActive && dropContext === 'simulacion' }
                                ]"
                                height="100"
                                outlined
                                rounded
                                @click="openPicker('noCombustible')"
                                @dragover.prevent="onDragOver('noCombustible', $event)"
                                @dragleave.prevent="onDragLeave('noCombustible')"
                                @dragend.prevent="onDragLeave('noCombustible')"
                                @drop.prevent="onDrop('noCombustible', $event)"
                              >
                                <v-icon
                                  size="28"
                                  class="mb-2 grey--text text--darken-1"
                                >
                                  mdi-file-upload-outline
                                </v-icon>

                                <div
                                  class="body-2 grey--text text--darken-1"
                                >
                                  Arrastra aquí tu archivo
                                  <span
                                    class="font-weight-medium"
                                  >.zip</span> (SHP) o
                                  <span
                                    class="font-weight-medium"
                                  >.kml</span>
                                </div>

                                <div
                                  class="caption grey--text text--darken-1 mt-1"
                                >
                                  o haz click para buscarlo
                                </div>
                              </v-sheet>

                              <input
                                ref="fileInputNoCombustible"
                                type="file"
                                accept=".zip,.kml"
                                style="display:none"
                                @change="onFileChange('noCombustible', $event)"
                              >
                            </v-col>
                          </v-row>

                          <v-data-table
                            v-if="tipoSimulacion === 'INCENDIO'"
                            v-show="zonasNoCombustibles.length !== 0"
                            :headers="[
                              { text: 'Nombre', sortable: false },
                              { text: 'Eliminar', sortable: false },
                            ]"
                            :items="zonasNoCombustibles"
                            hide-default-footer
                            disable-pagination
                          >
                            <template
                              #item="{ item }"
                            >
                              <tr>
                                <td
                                  class="text-xs-left"
                                >
                                  {{ item.tipo }} {{ item.id }}
                                </td>
                                <td>
                                  <v-btn
                                    icon
                                    small
                                    @click="eliminarZonaNoCombustible(item)"
                                  >
                                    <v-icon
                                      small
                                      color="error"
                                    >
                                      esri-icon-trash
                                    </v-icon>
                                  </v-btn>
                                </td>
                              </tr>
                            </template>
                          </v-data-table>
                          <v-row
                            v-if="tipoSimulacion === 'INCENDIO'"
                            v-show="zonasNoCombustibles.length !== 0"
                            class="pt-2"
                            dense
                          >
                            <v-col
                              align="center"
                            >
                              <v-btn
                                rounded
                                small
                                @click="eliminarAllZonasNoCombustibles()"
                              >
                                <v-icon
                                  small
                                  color="error"
                                >
                                  esri-icon-trash
                                </v-icon>
                                Eliminar todo
                              </v-btn>
                            </v-col>
                          </v-row>

                          <v-row
                            v-if="tipoSimulacion === 'INCENDIO'"
                            dense
                            class="mt-7"
                          >
                            <p
                              class="text-h6 black--text"
                            >
                              <v-icon>esri-icon-comment</v-icon>
                              Observaciones
                            </p>
                          </v-row>
                          <v-row
                            v-if="tipoSimulacion === 'INCENDIO'"
                            class="my-0"
                          >
                            <v-col
                              class="pl-6"
                            >
                              <v-textarea
                                v-model="observaciones"
                                label="Observaciones"
                                dense
                                outlined
                                auto-grow
                                hide-details
                              />
                            </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-container>
                </v-form>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- ------------------Tab lista------------------------ -->
          <v-tab-item
            key="ListaSimulaciones"
          >
            <v-card>
              <v-card-text>
                <v-form>
                  <v-container>
                    <v-row
                      align="center"
                      class="pl-6"
                    >
                      <v-col>
                        <vx-date-text-edit
                          v-model="fechaDesde"
                          label="Desde"
                          icon="esri-icon-calendar"
                          only-date
                          :max="fechaHasta"
                          not-future
                          required
                        />
                      </v-col>
                      <v-col>
                        <vx-date-text-edit
                          v-model="fechaHasta"
                          label="Hasta"
                          icon="esri-icon-calendar"
                          only-date
                          :min="fechaDesde"
                          not-future
                          required
                        />
                      </v-col>
                      <v-col>
                        <v-btn
                          icon
                          :loading="isLoadingSimulaciones"
                          @click="refreshSimulaciones"
                        >
                          <v-icon>mdi-reload</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col>
                        <v-data-table
                          :headers="headers"
                          :items="simulacionesTabla"
                          fixed-header
                          sort-by="FECHA_CREACION"
                          sort-desc
                          disable-pagination
                          hide-default-footer
                          :expanded="filasExpandidas"
                          item-key="ID_SIMULACION"
                          :item-class="getRowClass"
                          single-expand
                          @click:row="handleRowClick"
                        >
                          <template
                            #no-data
                          >
                            <p>Datos no disponibles.</p>
                          </template>

                          <template
                            #[`item.ICON`]="{ item }"
                          >
                            <v-tooltip
                              bottom
                            >
                              <template
                                #activator="{ on, attrs }"
                              >
                                <v-icon
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  {{ item.tipoItem === 'INCENDIO' ? 'mdi-fire' : 'mdi-weather-windy' }}
                                </v-icon>
                              </template>
                              <span>{{ item.tipoItem === 'INCENDIO' ? 'Simulación de Incendio' : 'Simulación de Viento' }}</span>
                            </v-tooltip>
                          </template>

                          <template
                            #[`item.NOMBRE`]="{ item }"
                          >
                            {{ item.NOMBRE ? item.NOMBRE : 'Sin nombre' }}
                          </template>

                          <template
                            #[`item.FECHA_CREACION`]="{ item }"
                          >
                            {{ item.FECHA_CREACION | formatDate }}
                          </template>

                          <template
                            #[`item.FECHA_INICIO`]="{ item }"
                          >
                            {{ item.FECHA_INICIO | formatDate }}
                          </template>

                          <template
                            #[`item.ACCIONES`]="{ item }"
                          >
                            <div
                              class="d-flex justify-end align-center"
                              style="gap: 4px;"
                            >
                              <v-tooltip
                                bottom
                              >
                                <template
                                  #activator="{ on, attrs }"
                                >
                                  <v-btn
                                    v-show="isSimVisible(item)"
                                    icon
                                    x-small
                                    v-bind="attrs"
                                    :color="simulacionActiva === item.ID_SIMULACION ? 'blue darken-2' : 'grey darken-1'"
                                    v-on="on"
                                    @click="seleccionarSimulacionActiva(item)"
                                  >
                                    <v-icon>
                                      {{ simulacionActiva === item.ID_SIMULACION ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <span>{{ simulacionActiva === item.ID_SIMULACION ? 'Cerrar detalles' : 'Ver detalles y enfocar' }}</span>
                              </v-tooltip>

                              <v-tooltip
                                bottom
                              >
                                <template
                                  #activator="{ on }"
                                >
                                  <v-btn
                                    icon
                                    x-small
                                    :disabled="item.ESTADO !== 'COMPLETED'"
                                    v-on="on"
                                    @click="handleEyeClick(item)"
                                  >
                                    <v-icon
                                      color="black"
                                    >
                                      {{ isSimVisible(item) ? 'mdi-eye-off' : 'mdi-eye' }}
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <span>{{ isSimVisible(item) ? 'Ocultar' : 'Visualizar' }}</span>
                              </v-tooltip>

                              <v-menu
                                bottom
                                right
                              >
                                <template
                                  #activator="{ on: onMenu }"
                                >
                                  <v-tooltip
                                    bottom
                                  >
                                    <template
                                      #activator="{ on: onTooltip }"
                                    >
                                      <v-btn
                                        icon
                                        x-small
                                        :disabled="item.ESTADO !== 'COMPLETED'"
                                        v-on="{ ...onMenu, ...onTooltip }"
                                      >
                                        <v-icon
                                          color="black"
                                        >
                                          mdi-download
                                        </v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Descargar como...</span>
                                  </v-tooltip>
                                </template>
                                <v-list>
                                  <v-list-item
                                    v-if="item.tipoItem === 'INCENDIO'"
                                    @click="descargarSimulacion(item, 'blob', 'SHP')"
                                  >
                                    <v-list-item-title>Shapefile (.shp)</v-list-item-title>
                                  </v-list-item>
                                  <v-list-item
                                    @click="descargarSimulacion(item, 'blob', 'KML')"
                                  >
                                    <v-list-item-title>Keyhole (.kml)</v-list-item-title>
                                  </v-list-item>
                                  <v-list-item
                                    v-if="item.tipoItem === 'INCENDIO'"
                                    @click="descargarSimulacionPDF(item)"
                                  >
                                    <v-list-item-title>Documento PDF (.pdf)</v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-menu>

                              <v-menu
                                bottom
                                right
                              >
                                <template
                                  #activator="{ on: onMenu }"
                                >
                                  <v-tooltip
                                    bottom
                                  >
                                    <template
                                      #activator="{ on: onTooltip }"
                                    >
                                      <v-btn
                                        icon
                                        x-small
                                        :disabled="item.ESTADO !== 'COMPLETED'"
                                        v-on="{ ...onMenu, ...onTooltip }"
                                      >
                                        <v-icon
                                          color="black"
                                        >
                                          mdi-link
                                        </v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Link de descarga</span>
                                  </v-tooltip>
                                </template>
                                <v-list>
                                  <v-list-item
                                    v-if="item.tipoItem === 'INCENDIO'"
                                    @click="descargarSimulacion(item, 'json', 'SHP')"
                                  >
                                    <v-list-item-title>Shapefile (.shp)</v-list-item-title>
                                  </v-list-item>
                                  <v-list-item
                                    @click="descargarSimulacion(item, 'json', 'KML')"
                                  >
                                    <v-list-item-title>Keyhole (.kml)</v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-menu>

                              <v-tooltip
                                bottom
                              >
                                <template
                                  #activator="{ on }"
                                >
                                  <v-btn
                                    icon
                                    x-small
                                    v-on="on"
                                    @click="deleteSimulacion(item)"
                                  >
                                    <v-icon
                                      color="red"
                                    >
                                      mdi-delete
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <span>Eliminar</span>
                              </v-tooltip>
                            </div>
                          </template>

                          <template
                            #expanded-item="{ headers: header, item }"
                          >
                            <td
                              :colspan="header.length"
                              class="pa-2 white"
                              style="border-bottom: 1px solid #e0e0e0; box-shadow: none;"
                            >
                              <v-alert
                                v-if="getStatusConfig(item.ESTADO).error"
                                type="error"
                                dense
                                prominent
                                text
                                class="mb-0"
                              >
                                <template
                                  #prepend
                                >
                                  <v-icon
                                    size="20"
                                    color="red"
                                  >
                                    mdi-close-circle-outline
                                  </v-icon>
                                </template>
                                Error en la simulación, vuelva a intentarlo
                              </v-alert>

                              <v-alert
                                v-else-if="item.ESTADO !== 'COMPLETED'"
                                dense
                                color="blue lighten-5"
                                class="mb-0"
                              >
                                <v-row
                                  align="center"
                                  no-gutters
                                >
                                  <v-col
                                    cols="auto"
                                    class="mr-3"
                                  >
                                    <v-icon
                                      color="blue"
                                    >
                                      mdi-information-outline
                                    </v-icon>
                                    <span
                                      class="blue--text font-weight-bold ml-2"
                                    >Procesando</span>
                                  </v-col>
                                  <v-col>
                                    <v-progress-linear
                                      :value="getStatusConfig(item.ESTADO).p"
                                      height="20"
                                      rounded
                                      reactive
                                      color="blue-grey darken-3"
                                    >
                                      <template
                                        #default="{ value }"
                                      >
                                        <strong
                                          class="white--text"
                                        >{{ Math.ceil(value) }}%</strong>
                                      </template>
                                    </v-progress-linear>
                                  </v-col>
                                </v-row>
                              </v-alert>

                              <div v-else class="rounded grey lighten-4 pa-4" style="padding-left: 66px !important;">
                                <v-row dense>
                                  <v-col>
                                    <div class="mb-2">
                                      <strong>Tipo:</strong> {{ item.TIPO === 'INCENDIO' ? 'Incendio' : 'Viento' }}
                                    </div>

                                    <div class="mb-2">
                                      <strong>Duración:</strong> {{ item.NUM_HORAS }} horas
                                    </div>

                                    <div class="mb-2">
                                      <strong>Intervalo:</strong> {{ item.INTERVALO }} minutos
                                    </div>

                                    <div class="mb-2">
                                      <strong>Incendio asociado:</strong> {{ item.ID_INCENDIO ? obtenerNombreIncendio(item.ID_INCENDIO) : 'No asociado' }}
                                    </div>

                                    <div class="mb-2">
                                      <strong>Viento activados:</strong> {{ item.VIENTOS ? 'Si' : 'No' }}
                                    </div>
                                  </v-col>
                                </v-row>
                              </div>
                            </td>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>

    <div
      v-show="(tabActiva === 0 && !disabledByRol) && !isCollapsed"
      class="sim-footer-fixed"
    >
      <div
        class="d-flex w-100"
      >
        <v-btn
          class="btn-footer-reset flex-grow-1 mr-2"
          depressed
          @click="resetCampos"
        >
          BORRAR DATOS
        </v-btn>

        <v-btn
          class="btn-footer-simular flex-grow-1"
          :disabled="!geometria || downloadingMeteo"
          depressed
          @click="simular"
        >
          SIMULAR
        </v-btn>
      </div>
    </div>

    <!-- Snackbar loading -->
    <v-snackbar
      v-model="isLoadingRequest"
      bottom
      :timeout="-1"
      class="snackbar-above-footer"
    >
      Enviando petición de simulación...
      <template
        #action="{ attrs }"
      >
        <v-progress-circular
          indeterminate
          v-on="attrs"
        />
      </template>
    </v-snackbar>

    <!-- Snackbar meteo -->
    <v-snackbar
      v-model="downloadingMeteo"
      bottom
      :timeout="-1"
      class="snackbar-above-footer"
    >
      Descargando meteorología
      <template
        #action="{ attrs }"
      >
        <v-progress-circular
          indeterminate
          v-on="attrs"
        />
      </template>
    </v-snackbar>

    <!-- Snackbar error y success -->
    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :top="true"
      :timeout="3000"
      class="snackbar-above-footer"
    >
      <v-icon>mdi-alert</v-icon>
      {{ snackbarText }}
    </v-snackbar>

    <vx-modelos-combustible
      class="mt-4"
      :show="showDialogModelosCombustible"
      :edit="modelosCombustibleEdit"
      :filas="modelosCombustibleEdit ? modelosCombustibleFilas : modelosHumedadFilas"
      @aceptar="acceptModelosCombustible"
      @cancelar="cancelModelosCombustible"
    />
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import * as ArcGIS from '@/helpers/ArcGIS'
import * as MunicipioAPI from '@/helpers/MunicipioAPI'
import ModelosCombustible from './ModelosCombustible.vue'
import DateService, { FMT, DayjsUnit } from '@/helpers/DateService'

export default {
  components: {
    'vx-modelos-combustible': ModelosCombustible
  },

  props: {
    show: Boolean,
    simMapa: Object
  },

  data: () => ({
    tipoSimulacion: 'INCENDIO',
    panelAjustesAvanzados: 1,
    nombreSimulacion: null,
    observaciones: null,
    isValid: false,

    rulesNumHoras: [
      (v) => !!v || 'Campo obligatorio.',
      (v) => (!!v && v >= 4 && v <= 12) || 'Núm. inválido.'
    ],
    rulesHumedad: [
      (v) => !!v || 'Campo obligatorio.',
      (v) => (!!v && v >= 20 && v <= 300) || 'Núm. inválido.'
    ],
    rulesIntervaloTiempo: [
      (v) => !!v || 'Campo obligatorio.',
      (v) => (!!v && v >= 15 && v <= 240) || 'Núm. inválido.'
    ],

    tabsGraficos: ['Selección Manual', 'Coordenadas', 'Subir archivo'],
    dragActive: false,
    fileDrop: null,
    dropContext: null,
    tabActivaGraficos: null,
    tabActiva: null,

    // Coordenadas
    latitud: null,
    longitud: null,

    // Graficos
    listGraphics: [],

    // Focos de incendio
    focos: [],
    editableFocoId: null,

    // Nueva simulacion
    isLoadingRequest: false,

    showSnackbar: false,
    snackbarColor: 'green',
    snackbarText: '',

    tipoGeometria: null,
    geometria: null,
    fechaInicio: null,
    numHoras: 8,
    intervaloOptions: ['15', '30', '60'],
    intervaloIndex: 2,
    humedadCombustible: 50,
    humedadVegetacion: 50,
    intervaloTiempo: 60,

    // Incendio asociado
    incendioSeleccionado: null,

    // Meteo
    vientosLocales: false,
    resolucionPersonalizada: false,
    resolucionViento: 200,
    minResolucionViento: 100,
    maxResolucionViento: 500,
    stepResolucionViento: 50,
    useCustomMeteo: false,
    downloadingMeteo: false,
    coordXMeteo: 0,
    coordYMeteo: 0,
    humedadLeñoso: 10,
    humedadHerbaceo: 10,
    meteoData: [
      { ID: 'temperatura', VARIABLE: 'Temperatura', CHECK: false, VALORES: [], DECIMALES: 0 },
      { ID: 'humedad', VARIABLE: 'Humedad', CHECK: false, VALORES: [], DECIMALES: 0 },
      { ID: 'nubosidad', VARIABLE: 'Nubosidad', CHECK: false, VALORES: [], DECIMALES: 0 },
      { ID: 'viento', VARIABLE: 'Viento', CHECK: false, VALORES: [], DECIMALES: 0 },
      { ID: 'direccionViento', VARIABLE: 'Direccion del viento', CHECK: false, VALORES: [], DECIMALES: 0 },
      { ID: 'precipitacion', VARIABLE: 'Precipitacion', CHECK: false, VALORES: [], DECIMALES: 0 }
    ],
    meteoDataDowloaded: [],
    modelosMeteo: null,
    modeloSeleccionado: null,

    // Listado simulaciones
    isLoadingSimulaciones: false,
    simulacionesVista: [],
    simulacionActiva: null,
    fechaDesde: null,
    fechaHasta: null,
    fechaFin: null,
    headers: [
      {
        text: '',
        value: 'ICON',
        align: 'left',
        sortable: false
      },
      {
        text: 'Nombre Simulación',
        value: 'NOMBRE',
        align: 'left',
        sortable: false
      },
      {
        text: 'Fecha creación',
        value: 'FECHA_CREACION',
        align: 'left',
        sortable: true
      },
      {
        text: 'Fecha de inicio',
        value: 'FECHA_INICIO',
        align: 'left',
        sortable: true
      },
      {
        text: '',
        value: 'ACCIONES',
        align: 'right',
        sortable: false
      }
    ],
    graphics: [],
    cacheMunicipios: {},

    esriButtons: [
      { id: 'point', label: 'Punto', icon: 'esri-icon-radio-checked' },
      { id: 'polyline', label: 'Línea', icon: 'esri-icon-polyline' },
      { id: 'polygon', label: 'Polígono', icon: 'esri-icon-polygon' }
    ],

    // Variables modelos combustibles
    combustibles: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],

    areasDeCombustibles: [],

    combustible: null,
    modeloCombustible: null,
    activarFuegoCopas: false,
    humedadFoliar: 100,
    fuegoCopasSelected: null,
    metodosFuegoCopas: [
      'Finney (2004)',
      'Scott/Reinhardt (2001)'
    ],
    contextoImportarShp: null,
    showDialogModelosCombustible: false,
    modelosCombustibleEdit: false,
    modelosCombustibleFilas: null,
    modelosHumedadFilas: null,

    // Variables zonas no combustibles
    zonasNoCombustibles: [],

    zonaNoCombustible: null,
    municipio: null,

    sketchIniciado: false,
    isCollapsed: false,
    navigation: {
      width: 600,
      borderSize: 3,
      minWidth: 550
    }

  }),

  computed: {
    ...mapGetters({
      getSimulaciones: 'simulacion/simulaciones',
      getSimulacionesWind: 'simulacion/simulacionesWind',
      isCurrentUsuarioAdmin: 'usuario/isCurrentUsuarioAdmin',
      getIncendioByID: 'incendio/getIncendioByID',
      getIncendios: 'incendio/incendios'
    }),

    simulaciones () {
      return this.getSimulaciones
    },

    simulacionesWind () {
      return this.getSimulacionesWind
    },

    simulacionesEnProgreso () {
      const data = this.simulacionesTabla
      return data.filter(item => this.estadoProgres(item) && item.ESTADO !== 'COMPLETED')
    },

    filasExpandidas () {
      const expandidas = [...this.simulacionesEnProgreso]

      if (this.simulacionActiva) {
        const data = this.simulacionesTabla
        const simActiva = data.find(s => s.ID_SIMULACION === this.simulacionActiva)

        if (simActiva && !expandidas.find(e => e.ID_SIMULACION === simActiva.ID_SIMULACION)) {
          expandidas.push(simActiva)
        }
      }
      return expandidas
    },

    incendios () {
      return this.getIncendios
    },

    disabledByRol () {
      // Deshabilita funciones dependiendo del rol
      return !this.isCurrentUsuarioAdmin
    },

    textoGeometria () {
      let txt = ''

      if (this.tipoGeometria !== null && this.geometria) {
        const numPuntos = this.geometria.length
        switch (this.tipoGeometria) {
          case 0:
            txt += `Punto ${this.geometria.map((x) => Math.trunc(x))}`
            break
          case 1:
            txt += `Línea - ${numPuntos} puntos`
            break
          case 2:
            txt += `Polígono - ${numPuntos - 1} puntos`
            break
        }
      }

      return txt
    },

    meteoHeaders () {
      const headers = []

      headers.push({ text: 'Variables', sortable: false, value: 'VARIABLE' })
      headers.push({ text: 'Repetir dato', sortable: false, value: 'REPETIR_DATO' })
      for (let i = -1; i < this.numHoras + 1; i++) {
        let headerName = (i < 10 && i >= 0) ? `0${i}` : i
        headerName += 'h'
        headers.push({ text: headerName, sortable: false, value: i })
      }

      return headers
    },

    meteoHeadersWind () {
      const headers = []

      headers.push({ text: 'Variables', sortable: false, value: 'VARIABLE' })
      for (let i = -1; i < this.numHoras + 1; i++) {
        let headerName = (i < 10 && i >= 0) ? `0${i}` : i
        headerName += 'h'
        headers.push({ text: headerName, sortable: false, value: i })
      }

      return headers
    },

    tabs () {
      if (this.disabledByRol) {
        return ['Lista de simulaciones']
      }
      return ['Nueva simulación', 'Lista de simulaciones']
    },
    intervaloMin: {
      get () {
        return this.intervaloOptions[this.intervaloIndex]
      },
      set (val) {
        const idx = this.intervaloOptions.indexOf(val)
        if (idx !== -1) this.intervaloIndex = idx
      }
    },

    tickLabelsHoras () {
      const labels = []
      for (let h = 1; h <= 12; h++) {
        labels.push(h === 1 || h === 12 ? String(h) : '')
      }
      return labels
    },

    tickLabelsViento () {
      const labels = []
      const steps = (this.maxResolucionViento - this.minResolucionViento) / this.stepResolucionViento

      for (let i = 0; i <= steps; i++) {
        if (i === 0) {
          labels.push(this.minResolucionViento.toString())
        } else if (i === steps) {
          labels.push(this.maxResolucionViento.toString())
        } else {
          labels.push('') // ticks intermedios sin texto
        }
      }

      return labels
    },

    simulacionesTabla () {
      const incendios = this.simulaciones.map(s => ({
        ...s,
        tipoItem: 'INCENDIO'
      }))

      const vientos = this.simulacionesWind.map(s => ({
        ...s,
        tipoItem: 'VIENTO'
      }))

      return [...incendios, ...vientos]
    }
  },

  watch: {
    show () {
      if (this.show && !this.geometria) {
        this.isCollapsed = false
        this.fechaInicio = this.$date.currentDate()
        this.numHoras = 8

        this.fechaHasta = this.$date.now().format(FMT.onlyDate)
        this.fechaDesde = this.$date
          .now()
          .subtract(7, DayjsUnit.Day)
          .format(FMT.onlyDate)
        this.refreshSimulaciones()
      }
    },

    fechaInicio () {
      this.actualizarFechaFin()
    },

    fechaFin () {
      if (this.fechaInicio) {
        const fecha = this.$date
          .parseDate(this.fechaInicio, FMT.date)
          .add(this.numHoras, DayjsUnit.Hour)

        if (fecha.isValid()) {
          this.fechaFin = fecha.format(FMT.date)
        }
      }
    },

    numHoras () {
      this.actualizarFechaFin()
    },

    async geometria () {
      if (!this.nombreSimulacion) {
        await this.construirNombre()
      }

      if (!this.geometria && this.focos.length === 0) {
        this.resetCampos()
      }
    },

    intervaloIndex () {
      this.intervaloTiempo = this.intervaloOptions[this.intervaloIndex]
    },

    modeloSeleccionado () {
      if (!this.downloadingMeteo && this.geometria) {
        this.downloadMeteo()
      }
    },

    tipoSimulacion () {
      if (this.tipoSimulacion === 'INCENDIO') {
        this.tabsGraficos = ['Selección Manual', 'Coordenadas', 'Subir archivo']

        this.esriButtons = [
          { id: 'point', label: 'Punto', icon: 'esri-icon-radio-checked' },
          { id: 'polyline', label: 'Línea', icon: 'esri-icon-polyline' },
          { id: 'polygon', label: 'Polígono', icon: 'esri-icon-polygon' }
        ]

        this.numHoras = 8
      } else {
        this.tabsGraficos = ['Selección Manual', 'Coordenadas']

        this.esriButtons = [
          { id: 'point', label: 'Punto', icon: 'esri-icon-radio-checked' }
        ]

        this.intervaloIndex = 60
        this.numHoras = 4

        if (this.tabActiva === 0) {
          this.modeloSeleccionado = this.modelosMeteo?.find(x => x.ID === 'METEOGALICIA')
        }
      }
    },

    simMapa () {
      if (!this.simMapa) return
      this.simulacionActiva = this.simMapa.simulacion.ID_SIMULACION
    }
  },

  mounted () {
    this.setBorderWidth()
    this.setEvents()

    this.fuegoCopasSelected = this.metodosFuegoCopas[0]
    this.rellenarCombustibles()

    this.$eventHub.$on('stopSimulacionesVista', () => {
      this.simulacionesVista = []
      this.isCollapsed = false
      this.simulacionActiva = null
      this.$emit('collapse-state-changed', this.isCollapsed)
    })
  },

  methods: {
    async actualizarFechaFin () {
      if (this.fechaInicio && this.numHoras) {
        const fecha = this.$date
          .parseDate(this.fechaInicio, FMT.date)
          .add(this.numHoras, DayjsUnit.Hour)

        if (fecha.isValid()) {
          this.fechaFin = fecha.format(FMT.date)
        }
        await this.cambiarMeteo()
      }
    },

    // #region NUEVA SIMULACION
    initSketch (evt) {
      this.geometria = null
      this.$emit('close')

      switch (evt) {
        case 'point':
          this.tipoGeometria = 0
          break
        case 'polyline':
          this.tipoGeometria = 1
          break
        case 'polygon':
          this.tipoGeometria = 2
          break
      }

      const data = {
        categoria: 'foco',
        event: evt,
        callback: this.callbackGeometryDone
      }

      if (this.sketchIniciado) {
        this.$emit('paintSimulationSketch', data)
      } else {
        this.$emit('initSimulacionSketch', data)
      }
    },

    async callbackGeometryDone (geometry) {
      this.$emit('stopSimulacionSketch') // Cerrar snackbar y parar sketchview
      this.sketchIniciado = true
      if (!this.geometria) {
        this.geometria = geometry.coordinates
      }

      let tipo = null

      switch (this.tipoGeometria) {
        case 0:
          tipo = 'Punto'
          break
        case 1:
          tipo = 'Linea'
          break
        case 2:
          tipo = 'Área'
          break
      }

      const latLon = this.tipoGeometria === 0
        ? ArcGIS.convertirETRS89ToLatLon(geometry.coordinates[0], geometry.coordinates[1])
        : ArcGIS.convertirETRS89ToLatLon(geometry.coordinates[0][0], geometry.coordinates[0][1])

      const foco = {
        id:
          this.focos.length !== 0
            ? this.focos[this.focos.length - 1].id + 1
            : 0,
        latitud: latLon[1],
        longitud: latLon[0],
        tipo,
        categoria: 'foco',
        geometry
      }

      this.focos.push(foco)
      this.$emit('redrawSimulationElements', this.focos)
      this.coordXMeteo = foco.longitud
      this.coordYMeteo = foco.latitud
      if (this.focos.length === 1) {
        await this.downloadMeteo()
      }
    },

    async addPunto () {
      this.tipoGeometria = 0

      this.foco = {
        id:
          this.focos.length !== 0
            ? this.focos[this.focos.length - 1].id + 1
            : 0,
        latitud: parseFloat(this.latitud).toFixed(5),
        longitud: parseFloat(this.longitud).toFixed(5),
        tipo: 'Punto',
        categoria: 'foco',
        geometry: null
      }

      const data = {
        categoria: 'foco',
        event: 'point',
        callback: this.callbackAddPuntoDone,
        latitude: this.latitud,
        longitude: this.longitud,
        tipo: 'Punto'
      }

      this.$emit('addPointSimulation', data)
      if (this.focos.length === 1) {
        await this.downloadMeteo()
      }
    },

    callbackAddPuntoDone (geometry) {
      const color = [255, 0, 0, 0.5]

      const geometryCoords = {
        coordinates: [],
        symbol: {
          type: 'simple-marker',
          color,
          size: 6
        },
        type: 'point'
      }
      this.sketchIniciado = true
      try {
        geometryCoords.coordinates = ArcGIS.convertirLatLonToETRS89(parseFloat(geometry.geometry.latitude), parseFloat(geometry.geometry.longitude))
        this.foco.geometry = geometryCoords
        if (!this.geometria) {
          this.geometria = geometryCoords.coordinates
        }
        this.focos.push(this.foco)
        this.$emit('redrawSimulationElements', this.focos)
        this.coordXMeteo = this.focos[0].longitud
        this.coordYMeteo = this.focos[0].latitud
      } catch (err) {
        this.snackbarError('La coordenada debe tener latitud y longitud')
        this.eliminarFoco(this.foco)
      }
    },

    openPicker (contexto) {
      this.dropContext = contexto

      let refName = null
      if (contexto === 'simulacion') {
        refName = 'fileInputSimulacion'
      } else if (contexto === 'combustible') {
        if (!this.modelo) {
          this.snackbarError('Seleccione un modelo para poder importar el archivo')
          return
        }
        refName = 'fileInputCombustible'
      } else if (contexto === 'noCombustible') {
        refName = 'fileInputNoCombustible'
      }

      const input = this.$refs[refName]
      if (input) input.click()
    },

    onDragOver (contexto, e) {
      e.dataTransfer.dropEffect = 'copy'
      this.dropContext = contexto
      this.dragActive = true
    },

    onDragLeave (contexto) {
      if (this.dropContext === contexto) {
        this.dragActive = false
        this.dropContext = null
      }
    },

    async onDrop (contexto, e) {
      this.dragActive = false
      this.dropContext = null
      this.fileDrop = e.dataTransfer.files[0]
      await this.handleFiles(contexto)
    },

    async onFileChange (contexto, e) {
      this.fileDrop = e.target.files[0]
      await this.handleFiles(contexto)
      e.target.value = ''
    },

    async handleFiles (contexto) {
      let type
      this.fileDrop.name.split('.')[1] === 'zip' ? type = 'shp' : type = 'kml'

      const geometry = await ArcGIS.insertLayer(this.fileDrop, type.toUpperCase(), true)

      for (let i = 0; i < geometry.length; i++) {
        const geometryFix = await this.formatGeometry(geometry[i])

        geometryFix.symbol.type = 'esriSFS'
        geometryFix.symbol.style = 'esriSFSSolid'
        geometryFix.symbol.outline.style = 'esriSLSSolid'
        geometryFix.symbol.outline.type = 'esriSLS'

        if (contexto === 'simulacion') {
          this.geometria = geometryFix
          this.tipoGeometria = 2
          const latLon = ArcGIS.convertirETRS89ToLatLon(geometryFix.coordinates[0][0], geometryFix.coordinates[0][1])

          const foco = {
            id: this.focos.length !== 0 ? this.focos[this.focos.length - 1].id + 1 : 0,
            latitud: latLon[1].toFixed(5),
            longitud: latLon[0].toFixed(5),
            tipo: 'Área',
            categoria: 'foco',
            geometry: {
              coordinates: geometryFix.coordinates,
              type: geometryFix.type,
              symbol: geometryFix.symbol
            }
          }

          this.coordXMeteo = foco.longitud
          this.coordYMeteo = foco.latitud
          this.focos.push(foco)

          this.$emit('redrawSimulationElements', this.focos)
          if (this.focos.length === 1) {
            await this.downloadMeteo()
          }
        } else if (contexto === 'combustible') {
          const idAux = this.areasDeCombustibles.length !== 0
            ? this.areasDeCombustibles[this.areasDeCombustibles.length - 1].id + 1
            : 0

          this.combustible = {
            id: idAux,
            geometry: {
              coordinates: geometryFix.coordinates,
              type: geometryFix.type,
              symbol: geometryFix.symbol
            },
            categoria: 'combustible',
            modelo: this.modelo
          }

          this.areasDeCombustibles.push(this.combustible)
          this.$emit('redrawSimulationElements', this.areasDeCombustibles)
        } else if (contexto === 'noCombustible') {
          const idAux = this.zonasNoCombustibles.length !== 0
            ? this.zonasNoCombustibles[this.zonasNoCombustibles.length - 1].id + 1
            : 0

          this.zonaNoCombustible = {
            id: idAux,
            geometry: {
              coordinates: geometryFix.coordinates,
              type: geometryFix.type,
              symbol: geometryFix.symbol
            },
            tipo: 'Zona no combustible',
            categoria: 'zonaNoCombustible'
          }

          this.zonasNoCombustibles.push(this.zonaNoCombustible)
          this.$emit('redrawSimulationElements', this.zonasNoCombustibles)
        }
      }
    },

    formatGeometry (geometry) {
      const mapCoords = (coords) => {
        if (coords.length >= 2 && typeof coords[0] === 'number' && typeof coords[1] === 'number') {
          return ArcGIS.convertirMercXYToETRS89UTM30N(coords[0], coords[1])
        }
        return coords.map(mapCoords)
      }

      let coordsOut = mapCoords(geometry.geometry.rings[0])

      if (coordsOut[0].length > 2) {
        coordsOut = coordsOut.flat(1)
      }

      return { ...geometry, coordinates: coordsOut }
    },

    async construirNombre () {
      const fechaNombre = this.$date.now().format(FMT.date)
      const pointData = await MunicipioAPI.getLatLonData(this.coordXMeteo, this.coordYMeteo)
      this.municipio = pointData.MUNICIPIO

      if (pointData.LOCALIDAD === pointData.MUNICIPIO) {
        this.nombreSimulacion = `${pointData.MUNICIPIO} - ${fechaNombre}`
      } else {
        this.nombreSimulacion = `${pointData.MUNICIPIO},${pointData.LOCALIDAD} - ${fechaNombre}`
      }
    },

    rellenarCombustibles () {
      const rawModelData = `
        0 0 0 0 0 0
        1 1.66 0 0 0 0
        2 4.48 2.24 1.12 1.12 0
        3 6.75 0 0 0 0
        4 11.23 8.99 4.48 0 11.23
        5 2.24 1.12 0 0 4.48
        6 3.36 5.6 4.48 0 0
        7 2.53 4.19 3.36 0 0.83
        8 3.36 2.24 5.6 0 0
        9 6.55 0.92 0.34 0 0
        10 6.75 4.48 11.23 0 4.48
        11 3.36 10.11 12.35 0 0
        12 8.99 31.45 37.06 0 0
        13 15.71 51.65 62.88 0 0
      `

      const transformedData = rawModelData
        .trim()
        .split('\n')
        .map(line => {
          const values = line.trim().split(/\s+/).map(Number)
          return {
            FUEL_MODEL_TYPE: values[0],
            H1: values[1],
            H10: values[2],
            H100: values[3],
            LIVE_H: values[4],
            LIVE_W: values[5]
          }
        })
      this.modelosCombustibleFilas = transformedData
    },

    rellenarHumedades (humedad) {
      const fm1 = humedad / 5
      const fm10 = fm1 + 1
      const fm100 = fm1 + 2
      const fmLiveHerb = (fm100 + 1) * 10
      const fmLiveWood = fm1 * 10

      const valoresCalculados = {
        humidity: Math.floor(fm1),
        humidity10h: Math.floor(fm10),
        humidity100h: Math.floor(fm100),
        FLH: Math.floor(fmLiveHerb),
        FLW: Math.floor(fmLiveWood)
      }

      this.modelosHumedadFilas = Array.from({ length: 14 }, (_, index) => ({
        model: index,
        ...valoresCalculados
      }))
    },

    onEditarCargaModelos () {
      this.modelosCombustibleEdit = true
      this.showDialogModelosCombustible = true
    },
    onEditarHumedadModelos () {
      this.modelosCombustibleEdit = false
      this.showDialogModelosCombustible = true
    },

    acceptModelosCombustible (payload) {
      let msg
      if (this.modelosCombustibleEdit) {
        this.modelosCombustibleFilas = payload.filas

        msg = 'Carga de los modelos de combustible actualizada correctamente'
      } else {
        this.modelosHumedadFilas = payload.filas.map(fila => ({
          model: fila.FUEL_MODEL_TYPE,
          humidity: fila.H1,
          humidity10h: fila.H10,
          humidity100h: fila.H100,
          FLH: fila.LIVE_H,
          FLW: fila.LIVE_W
        }))

        msg = 'Humedad de los modelos de combustible actualizada correctamente'
      }

      this.showDialogModelosCombustible = false
      this.snackbarSuccess(msg)
    },

    cancelModelosCombustible () {
      this.modelosCombustibleEdit = false
      this.showDialogModelosCombustible = false
    },

    async eliminarFoco (foco) {
      const index = this.focos.indexOf(foco)
      this.focos.splice(index, 1)
      if (index === 0) {
        for (let i = 0; i < this.meteoData.length; i++) {
          this.meteoData[i].VALORES = []
        }
        this.geometria = null

        if (this.focos.length > 0) {
          this.coordXMeteo = this.focos[0].longitud
          this.coordYMeteo = this.focos[0].latitud
          this.nombreSimulacion = null
          this.geometria = this.focos[0].geometry.coordinates

          await this.downloadMeteo()
        }
      }

      this.repintarAll()
    },

    eliminarAllFocos () {
      this.focos = []
      for (let i = 0; i < this.meteoData.length; i++) {
        this.meteoData[i].VALORES = []
      }
      this.geometria = null
      this.repintarAll()
    },

    // Zona modelos combustibles
    initModeloCombustible (evt) {
      this.$emit('close')

      const idAux =
        this.areasDeCombustibles.length !== 0
          ? this.areasDeCombustibles[this.areasDeCombustibles.length - 1].id + 1
          : 0

      this.combustible = {
        id: idAux,
        geometry: null,
        categoria: 'combustible',
        modelo: this.modelo
      }

      const data = {
        categoria: 'combustible',
        event: evt,
        callback: this.callbackModeloCombustibleDone
      }

      if (this.sketchIniciado) {
        this.$emit('paintSimulationSketch', data)
      } else {
        this.$emit('initSimulacionSketch', data)
      }
    },

    callbackModeloCombustibleDone (geometry) {
      this.$emit('stopSimulacionSketch') // Cerrar snackbar y parar sketchview
      this.sketchIniciado = true
      this.combustible.geometry = geometry

      this.areasDeCombustibles.push(this.combustible)
    },

    eliminarModeloCombustible (modelo) {
      const index = this.areasDeCombustibles.indexOf(modelo)
      this.areasDeCombustibles.splice(index, 1)

      this.repintarAll()
    },

    eliminarAllModelosCombustible () {
      this.areasDeCombustibles = []
      this.repintarAll()
    },

    // Zona de zonas no combustibles
    initZonasNoCombustibles (evt) {
      this.$emit('close')

      const idAux =
        this.zonasNoCombustibles.length !== 0
          ? this.zonasNoCombustibles[this.zonasNoCombustibles.length - 1].id + 1
          : 0

      this.zonaNoCombustible = {
        id: idAux,
        geometry: null,
        tipo: evt === 'polyline' ? 'Cortafuegos' : 'Zona no combustible',
        categoria: 'zonaNoCombustible'
      }

      const data = {
        categoria: 'zonaNoCombustible',
        event: evt,
        callback: this.callbackZonaNoCombustibleDone
      }

      if (this.sketchIniciado) {
        this.$emit('paintSimulationSketch', data)
      } else {
        this.$emit('initSimulacionSketch', data)
      }
    },

    callbackZonaNoCombustibleDone (geometry) {
      this.$emit('stopSimulacionSketch') // Cerrar snackbar y parar sketchview
      this.sketchIniciado = true
      this.zonaNoCombustible.geometry = geometry
      this.zonasNoCombustibles.push(this.zonaNoCombustible)
    },

    eliminarZonaNoCombustible (modelo) {
      const index = this.zonasNoCombustibles.indexOf(modelo)
      this.zonasNoCombustibles.splice(index, 1)
      this.repintarAll()
    },

    eliminarAllZonasNoCombustibles () {
      this.zonasNoCombustibles = []
      this.repintarAll()
    },

    repintarAll () {
      this.$emit('endSimulacionSketch')
      this.$emit('redrawSimulationElements', this.focos)
      this.$emit('redrawSimulationElements', this.zonasNoCombustibles)
      this.$emit('redrawSimulationElements', this.areasDeCombustibles)
    },

    getMeteoRules (idVariable) {
      const rules = []

      rules.push((v) => !!v || 'Campo obligatorio')
      switch (idVariable) {
        case 'temperatura':
          rules.push((v) => (!!v && v >= -60 && v <= 60) || 'Núm. inválido.')
          break
        case 'humedad_relativa':
        case 'nubosidad':
          rules.push((v) => (!!v && v >= 20 && v <= 300) || 'Núm. inválido.')
          break
        case 'mod_viento':
          rules.push((v) => (!!v && v >= 0) || 'Núm. inválido.')
          break
        case 'dir_viento':
          rules.push((v) => (!!v && v >= 0 && v <= 360) || 'Núm. inválido.')
          break
      }

      return rules
    },

    async cambiarMeteo () {
      try {
        if (this.geometria && !this.downloadingMeteo && !this.isLoadingRequest) {
          const fecha = this.$date
            .parseDate(this.fechaInicio, FMT.date)

          if (fecha.isValid() && this.numHoras && this.numHoras >= 4 && this.numHoras <= 12) {
            await this.downloadMeteo()
          }
        }
      } catch (err) {
        console.error(err)
        this.snackbarError('Error cambiando los datos de meteo')
      }
    },

    cambiarMeteoLinea (item, posi) {
      if (item.CHECK) {
        for (let i = 0; i < item.VALORES.length; i++) {
          item.VALORES[i] = item.VALORES[posi]
        }
      }
    },

    meteoCheck () {
      let i = 0
      while (i < this.meteoData.length && !this.useCustomMeteo) {
        const newData = JSON.parse(JSON.stringify(this.meteoData[i].VALORES))

        for (let j = 0; j < newData.length; j++) {
          if (newData[j] !== this.meteoDataDowloaded[i][j]) {
            this.useCustomMeteo = true
            break
          }
        }

        i++
      }
    },

    revertirCambiosMeteo () {
      for (let i = 0; i < this.meteoData.length; i++) {
        this.meteoData[i].VALORES = [...this.meteoDataDowloaded[i]]
      }

      this.useCustomMeteo = false
    },

    seleccionarModelo (modelo) {
      this.modeloSeleccionado = modelo
    },

    onChangeVientosLocales (val) {
      if (!val && this.resolucionPersonalizada) {
        this.resolucionPersonalizada = false
      }
    },
    onChangeResolucionPersonalizada (val) {
      if (val && !this.vientosLocales) {
        this.vientosLocales = true
      }
    },

    async getModelos (params) {
      try {
        this.modelosMeteo = await (await api.simulacion.getModelsByPosition(params)).data
        this.modelosMeteo.sort((a, b) => {
          const aTieneFecha = a && a.DATE
          const bTieneFecha = b && b.DATE

          if (aTieneFecha && !bTieneFecha) {
            return -1
          }

          if (!aTieneFecha && bTieneFecha) {
            return 1
          }

          return 0
        })

        if (this.tipoSimulacion === 'VIENTO') {
          this.modeloSeleccionado = this.modelosMeteo.find(x => x.ID === 'METEOGALICIA')
        } else {
          this.modeloSeleccionado = this.modelosMeteo[0]
        }
      } catch (err) {
        console.error(err)
        throw err
      }
    },

    async downloadMeteo () {
      if (!this.geometria) {
        this.snackbarError('Dibuje la geometría o seleccione las coordenadas')
        return
      }

      this.downloadingMeteo = true

      const x = this.coordXMeteo
      const y = this.coordYMeteo
      const fechaSinMins = `${this.fechaInicio?.substr(0, 14)}00`
      let fixFecha = null
      if (this.fechaInicio) {
        fixFecha = DateService.toDayjs(fechaSinMins, FMT.date).toISOString()
      }

      const params = {
        position: {
          lon: x,
          lat: y
        },
        date: fixFecha,
        duration: this.numHoras,
        model: null
      }

      try {
        if (!this.modelosMeteo) {
          await this.getModelos(params)
        }
        params.model = this.modeloSeleccionado

        const response = await api.simulacion.getSimulatorMeteo(params)
        const datos = response.data

        for (let i = 0; i < datos.length; i++) {
          const p = datos[i]

          p.VALORES = p.VALORES.map((v) => Math.round(v * 100) / 100)

          switch (p.ID) {
            case 'temperatura':
              this.meteoData[0].VALORES = p.VALORES
              break
            case 'humedad':
              this.meteoData[1].VALORES = p.VALORES
              break
            case 'nubosidad':
              this.meteoData[2].VALORES = p.VALORES
              break
            case 'viento':
              this.meteoData[3].VALORES = p.VALORES
              break
            case 'direccionViento':
              this.meteoData[4].VALORES = p.VALORES
              break
            case 'precipitacion':
              this.meteoData[5].VALORES = p.VALORES
              break
          }
        }

        this.rellenarHumedades(this.meteoData[1].VALORES[0])
      } catch (err) {
        console.error(err)
        this.snackbarError('Error descargando los datos de meteo')
        this.resetCampos()
      } finally {
        this.downloadingMeteo = false
        this.meteoDataDowloaded = []

        for (let i = 0; i < this.meteoData.length; i++) {
          const prevData = structuredClone(this.meteoData[i].VALORES)
          this.meteoDataDowloaded.push(prevData)
        }
      }
    },

    resetCampos () {
      this.$emit('endSimulacionSketch')
      this.geometria = null
      this.fechaInicio = this.$date.currentDate()
      this.numHoras = 8
      this.modelosMeteo = null
      this.modeloSeleccionado = null
      this.nombreSimulacion = null
      this.modeloCombustible = null

      this.incendioSeleccionado = null

      // Coordenadas
      this.tabActivaGraficos = 'SeleccionManual'
      this.latitud = null
      this.longitud = null

      // Graficos
      this.listGraphics = []

      // Focos de incendio
      this.focos = []

      this.areasDeCombustibles = []

      this.combustible = null
      this.modelo = null

      // Variables zonas no combustibles
      this.activarFuegoCopas = null
      this.fuegoCopasSelected = this.metodosFuegoCopas[0]
      this.zonasNoCombustibles = []

      this.zonaNoCombustible = null

      this.sketchIniciado = false

      this.humedadCombustible = 50
      this.humedadVegetacion = 50

      this.intervaloTiempo = 60

      this.humedadLeñoso = 10
      this.humedadHerbaceo = 10

      this.vientosLocales = false
      this.useCustomMeteo = false

      for (let i = 0; i < this.meteoData.length; i++) {
        this.meteoData[i].VALORES = []
        for (let j = 0; j < this.numHoras + 2; j++) {
          this.meteoData[i].VALORES.push(0)
        }
      }
      this.meteoDataDowloaded = []
    },

    async simular () {
      this.isLoadingRequest = true

      const graficos = []

      const meteoData = JSON.parse(JSON.stringify(this.meteoData))

      // Geometrias de los focos
      const geometrias = []

      const tipoGeometrias = []

      const centroSim = await ArcGIS.obtenerCentro(this.focos[0].geometry, 'INCENDIO', 25828)

      for (let i = 0; i < this.focos.length; i++) {
        // const auxGeometria = [this.focos[i].latitud, this.focos[i].longitud]
        if (this.focos[i].tipo === 'Punto') {
          geometrias.push([this.focos[i].geometry.coordinates])
        } else {
          geometrias.push(this.focos[i].geometry.coordinates)
        }

        let tipo

        switch (this.focos[i].tipo) {
          case 'Punto':
            tipo = 0
            break
          case 'Linea':
            tipo = 1
            break
          case 'Área':
            tipo = 2
            break
        }

        tipoGeometrias.push(tipo)
      }

      // Geometrias de los cortafuegos
      const geometriasCortafuegos = []

      const tipoGeometriasCortaFuegos = []

      for (let i = 0; i < this.zonasNoCombustibles.length; i++) {
        geometriasCortafuegos.push(this.zonasNoCombustibles[i].geometry.coordinates)

        let tipo

        switch (this.zonasNoCombustibles[i].geometry.type) {
          case 'polyline':
            tipo = 1
            break
          case 'polygon':
            tipo = 2
            break
        }

        tipoGeometriasCortaFuegos.push(tipo)

        graficos.push({
          GEOMETRIA: this.zonasNoCombustibles[i].geometry.coordinates,
          TIPO_GEOMETRIA: this.zonasNoCombustibles[i].geometry.type,
          TIPO_GRAFICO: 'zonaNoCombustible'
        })
      }

      // Geometrias de los modelos de combustible
      const geometriasModeloComb = []

      const tiposModelosComb = []

      for (let i = 0; i < this.areasDeCombustibles.length; i++) {
        geometriasModeloComb.push(this.areasDeCombustibles[i].geometry.coordinates)

        const tipo = this.areasDeCombustibles[i].modelo

        tiposModelosComb.push(tipo)

        graficos.push({
          GEOMETRIA: this.areasDeCombustibles[i].geometry.coordinates,
          TIPO_GEOMETRIA: 'polygon',
          TIPO_MODELO_COMBUSTIBLE: tipo,
          TIPO_GRAFICO: 'combustible'
        })
      }

      // No funcionan los minutos en la simulacion asi que hay que ponerlos a 00
      this.fechaInicio = `${this.fechaInicio.substr(0, 14)}00`
      this.fechaFin = `${this.fechaFin.substr(0, 14)}00`

      const geoEnviada = ArcGIS.transformarAHuso30(geometrias)
      const cortaFuegosEnviado = ArcGIS.transformarAHuso30(geometriasCortafuegos)
      const combEnviado = ArcGIS.transformarAHuso30(geometriasModeloComb)

      // Creamos el objeto que pasar al simulador
      const fechaFixInicio = this.$date.gmtToUtc(this.fechaInicio)
        ? this.$date.parseDate(this.fechaInicio, FMT.date).subtract(1, DayjsUnit.Hour).format(FMT.simulation) // Horario Verano
        : this.$date.parseDate(this.fechaInicio, FMT.date).subtract(0, DayjsUnit.Hour).format(FMT.simulation) // Horario Invierno
      const fechaFixFin = this.$date.gmtToUtc(this.fechaFin)
        ? this.$date.parseDate(this.fechaFin, FMT.date).subtract(1, DayjsUnit.Hour).format(FMT.simulation) // Horario Verano
        : this.$date.parseDate(this.fechaFin, FMT.date).subtract(0, DayjsUnit.Hour).format(FMT.simulation) // Horario Invierno

      const meteoDataFinal = meteoData.map(d => {
        return {
          ...d,
          VALORES: d.VALORES.map(x => parseFloat(x))
        }
      })

      const meteoDataSim = meteoDataFinal.map(item => {
        const { CHECK, ...resto } = item
        return resto
      })

      const municipioSim = `${this.municipio}, Tenerife`

      let datosSimulador = null

      if (this.tipoSimulacion === 'INCENDIO') {
        const disabled = false
        this.modeloSeleccionado.disabled = disabled

        datosSimulador = {
          name: this.nombreSimulacion,
          observation: this.observaciones ? this.observaciones : '',
          geometry: geoEnviada,
          typeGeometry: tipoGeometrias,
          dateInit: fechaFixInicio,
          dateEnd: fechaFixFin,
          timeStep: this.intervaloTiempo,
          useWindNinja: this.vientosLocales ? 1 : 0,
          firewall: cortaFuegosEnviado,
          typeFirewall: tipoGeometriasCortaFuegos,
          useFirewall: geometriasCortafuegos.length === 0 ? 0 : 1,
          meteoData: meteoDataSim,
          useCustomMeteo: this.useCustomMeteo ? 1 : 0,
          fuelModel: tiposModelosComb.length === 0 ? [] : tiposModelosComb,
          fuelModelArea: combEnviado,
          municipality: municipioSim,
          simulationCenter: centroSim,
          fuelModelDefinition: this.modelosHumedadFilas,
          fuelModelLoads: this.modelosCombustibleFilas,
          crownFlag: 0,
          foliarMoisture: this.humedadFoliar,
          crownFireFinney: this.fuegoCopasSelected === this.metodosFuegoCopas[0] ? 1 : 0,
          selectedModel: this.modeloSeleccionado
        }

        if (this.vientosLocales) {
          const windNinjaResolution = 200 // TODO: windNinjaResolution: resolucionViento, esta comentado en el HTML
          datosSimulador.windNinjaResolution = windNinjaResolution
        }
      } else {
        const geoEnviadaViento = ArcGIS.transformarAHuso30(geometrias)

        const fechaFixInicioViento = this.$date.parseDate(this.fechaInicio, FMT.date).subtract(1, DayjsUnit.Hour).format(FMT.simulation)
        const fechaFixfinViento = this.$date.parseDate(this.fechaFin, FMT.date).subtract(1, DayjsUnit.Hour).format(FMT.simulation)

        datosSimulador = {
          name: this.nombreSimulacion,
          geometry: geoEnviadaViento,
          typeGeometry: tipoGeometrias,
          dateInit: fechaFixInicioViento,
          dateEnd: fechaFixfinViento,
          windNinjaResolution: 100,
          meteoData: meteoDataSim,
          useCustomMeteo: 0,
          municipality: municipioSim,
          simulationCenter: centroSim,
          selectedModel: this.modeloSeleccionado
        }
      }

      // Creamos el objeto para insertar en BDD
      const datosBackend = {
        FECHA_CREACION: this.$date.now(),
        FECHA_INICIO: this.$date.parseDate(
          this.fechaInicio,
          FMT.date
        ),
        NUM_HORAS: this.numHoras,
        INTERVALO: 60,
        NOMBRE: this.nombreSimulacion,
        VIENTOS: this.vientosLocales || this.tipoSimulacion === 'VIENTO' ? 1 : 0,
        GRAFICOS: graficos,
        ID_INCENDIO: this.incendioSeleccionado?.ID_INCENDIO
      }

      const data = {
        datosSimulador,
        tipo: this.tipoSimulacion,
        datosBackend
      }

      try {
        await this.$store.dispatch('simulacion/addSimulacion', data)
        this.snackbarSuccess('Simulación solicitada correctamente')
        this.tabActiva = 1
      } catch (err) {
        this.snackbarError('Error solicitando simulacion')
        /* await this.deleteSimulacion(this.simulaciones[0]) */
      } finally {
        this.resetCampos()
        this.refreshSimulaciones()
        this.isLoadingRequest = false
      }
    },

    snackbarError (msg) {
      this.showSnackbar = true
      this.snackbarColor = 'error'
      this.snackbarText = msg
    },
    snackbarSuccess (msg) {
      this.showSnackbar = true
      this.snackbarColor = 'success'
      this.snackbarText = msg
    },
    // #endregion

    // #region LISTADO SIMULACIONES
    async refreshSimulaciones () {
      this.isLoadingSimulaciones = true

      try {
        const data = {
          fechaDesde: this.$date
            .parseDate(this.fechaDesde, FMT.onlyDate)
            .format(FMT.dateFetch),
          fechaHasta: this.$date
            .parseDate(this.fechaHasta, FMT.onlyDate)
            .endOf(DayjsUnit.Day)
            .format(FMT.dateFetch)
        }
        await this.$store.dispatch('simulacion/fetchSimulaciones', data)
      } finally {
        this.isLoadingSimulaciones = false
      }
    },

    isSimVisible (item) {
      return !!this.simulacionesVista.includes(item.ID_SIMULACION)
    },

    toggleSimulacion (item) {
      const sim = ArcGIS.getSimulacionById(item.ID_SIMULACION)
      const index = this.simulacionesVista.indexOf(item.ID_SIMULACION)

      if (index === -1) {
        this.simulacionesVista.push(item.ID_SIMULACION)
      } else {
        this.simulacionesVista.splice(index, 1)
      }

      if (sim) {
        ArcGIS.eliminaSimulacion(item)
      } else {
        this.paintSimulacion(item, item.tipoItem)
      }
    },

    isRowExpanded (item) {
      return this.simulacionesEnProgreso.some(s => s.ID_SIMULACION === item.ID_SIMULACION)
    },

    seleccionarSimulacionActiva (item) {
      if (this.simulacionActiva === item.ID_SIMULACION) {
        this.simulacionActiva = null
      } else {
        this.simulacionActiva = item.ID_SIMULACION
        this.cambiarSimulacion(item.ID_SIMULACION)
      }
    },

    handleRowClick (item) {
      if (this.isSimVisible(item)) {
        this.seleccionarSimulacionActiva(item)
      }
    },

    getRowClass (item) {
      if (this.isSimVisible(item)) {
        return 'fila-clicable'
      }
      return ''
    },

    handleEyeClick (item) {
      this.toggleSimulacion(item)

      if (this.isSimVisible(item)) {
        this.simulacionActiva = item.ID_SIMULACION
        this.cambiarSimulacion(item.ID_SIMULACION)
      } else {
        if (this.simulacionActiva === item.ID_SIMULACION) {
          this.simulacionActiva = null
        }
      }
    },

    cambiarSimulacion (simId) {
      if (!simId) return
      ArcGIS.setSimulacionActivaId(simId)
      this.$eventHub.$emit('setSimulacionActiva', simId)

      const sim = ArcGIS.getSimulacionById(this.simulacionActiva)
      ArcGIS.centerSimulacion(sim?.sim.simulacion.TIPO, simId)
    },

    estadoProgres (item) {
      if (!item?.ESTADO) return false

      const config = this.getStatusConfig(item.ESTADO)

      return config.p < 100 || config.error
    },

    getStatusConfig (estado) {
      const map = {
        // Estados de Error
        ERROR: { p: 100, error: true },
        ERROR_REPORT_IGP: { p: 100, error: true },
        ERROR_CATASTRO: { p: 100, error: true },
        ERROR_IGP: { p: 100, error: true },
        ERROR_REPORT: { p: 100, error: true },
        TIME_OUT: { p: 100, error: true },

        // Estados de Progreso
        NEW: { p: 5, error: false },
        PREPROCESSING: { p: 15, error: false },
        GENERATING_INPUTS: { p: 25, error: false },
        SIMULATING: { p: 45, error: false },
        PROCESSING: { p: 60, error: false },
        PROCESSING_IGP: { p: 70, error: false },
        PROCESSING_CATASTRO: { p: 80, error: false },
        POSTPROCESSING: { p: 85, error: false },
        PROCESSING_REPORT: { p: 90, error: false },

        // Estados Finalizados
        COMPLETED: { p: 100, error: false },
        COMPLETED_CATASTRO: { p: 100, error: false },
        COMPLETED_REPORT: { p: 100, error: false }
      }

      return map[estado] || { p: 0, error: false }
    },

    paintSimulacion (simulacion, tipo) {
      const sim = {
        id: null,
        idIncendio: null,
        simulacion,
        isocronas: [],
        longitudLlama: [],
        intensidadLlama: [],
        velocidadPropagacion: [],
        graficosSimulacion: [],
        coordenadas: [],
        componente: 'dialog'
      }

      const data = {
        sim,
        id: 'simulacion'
      }

      if (tipo === 'INCENDIO') {
        this.$emit('paintSimulacion', data)
      } else {
        this.$emit('paintViento', sim)
      }
    },

    async deleteSimulacion (simulacion) {
      try {
        await this.$emit('deleteSimulacion', { simulacion, callback: this.refreshSimulaciones })
        this.snackbarSuccess('Simulación borrada correctamente')
      } catch (err) {
        this.snackbarError('Error borrando la simulacion')
      }
    },

    // Descarga directa u obtención de url. Dependiendo de responseType (json -> url, blob -> descarga)
    async descargarSimulacion (simulacion, responseType, fileType) {
      await ArcGIS.exportSimulacionBack(simulacion, responseType, fileType)
      if (responseType === 'json') {
        try {
          this.$notify(`Link de descarga de ${fileType} copiado al portapapeles`)
        } catch (error) {
          this.$notify(`Error al copiar el link de descarga de ${fileType} al portapapeles`)
          console.error('Error al copiar el link de descarga al portapapeles')
        }
      }
    },

    async descargarSimulacionPDF (simulacion) {
      try {
        const response = await api.simulacion.getSimulationPDF(simulacion.ID_SIMULACION)

        ArcGIS.downloadBlob(response.data, `Simulacion_${simulacion.ID_SIMULACION}.pdf`)
      } catch (error) {
        console.error('Error descargando el pdf de la simulacion: ', error)
        this.snackbarError('Error descargando el pdf de la simulacion')
      }
    },

    obtenerNombreIncendio (idIncendio) {
      if (this.cacheMunicipios[idIncendio]) {
        return this.cacheMunicipios[idIncendio]
      }

      if (this.cacheMunicipios[idIncendio] === undefined) {
        this.$set(this.cacheMunicipios, idIncendio, 'Cargando...')

        api.incendio.getIncendioById(idIncendio).then(res => {
          this.$set(this.cacheMunicipios, idIncendio, res.data.MUNICIPIO)
        }).catch(() => {
          this.$set(this.cacheMunicipios, idIncendio, 'Error')
        })
      }

      return this.cacheMunicipios[idIncendio]
    },
    // #endregion

    cerrar () {
      const tieneSimulaciones = this.simulacionesVista.length > 0

      if (tieneSimulaciones) {
        this.isCollapsed = !this.isCollapsed
        this.$emit('collapse-state-changed', this.isCollapsed)
      } else {
        this.isCollapsed = false
        this.resetCampos()
        this.$emit('close')
      }
    },

    setBorderWidth () {
      const i = this.$refs.drawer.$el.querySelector(
        '.v-navigation-drawer__border'
      )
      i.style.width = `${this.navigation.borderSize}px`
      i.style.cursor = 'ew-resize'
      i.style.backgroundColor = 'transparent'
    },

    setEvents () {
      const minSize = this.navigation.borderSize
      const el = this.$refs.drawer.$el
      const drawerBorder = el.querySelector('.v-navigation-drawer__border')
      const vm = this
      const direction = el.classList.contains('v-navigation-drawer--right')
        ? 'right'
        : 'left'

      function resize (e) {
        if (e.clientX < vm.navigation.minWidth) return
        document.body.style.cursor = 'ew-resize'
        const f =
          direction === 'right'
            ? document.body.scrollWidth - e.clientX
            : e.clientX
        el.style.width = `${f}px`
      }

      drawerBorder.addEventListener(
        'mousedown',
        (e) => {
          if (e.offsetX < minSize) {
            el.style.transition = 'initial'
            document.addEventListener('mousemove', resize, false)
          }
        },
        false
      )

      document.addEventListener(
        'mouseup',
        () => {
          el.style.transition = ''
          if (!this.isCollapsed) {
            this.navigation.width = el.style.width
          }
          document.body.style.cursor = ''
          document.removeEventListener('mousemove', resize, false)
        },
        false
      )
    }
  }
}
</script>

<style scoped>
/*CSS Menu posicionamiento*/
.tabs-graficos ::v-deep .v-tab {
  min-width: auto;
}

.tabs-graficos ::v-deep .v-slide-group__prev,
.tabs-graficos ::v-deep .v-slide-group__next {
  display: none !important;
}

/*CSS Drag and drop*/
.dropzone {
  border: 2px dashed rgba(0, 0, 0, .25);
  transition: .15s;
  cursor: pointer;
}

.dropzone--active {
  border-color: var(--v-primary-base);
  background: rgba(0, 0, 0, .03);
}

/*CSS Sliders*/
:root {
  --slider-main-color: #025f87;
}

.slider-iso ::v-deep .v-slider__track-container,
.slider-duracion ::v-deep .v-slider__track-container,
.slider-viento ::v-deep .v-slider__track-container {
  height: 6px;
  border-radius: 4px;
}

.slider-iso ::v-deep .v-slider__track-fill,
.slider-duracion ::v-deep .v-slider__track-fill,
.slider-viento ::v-deep .v-slider__track-fill,
.slider-iso ::v-deep .v-slider__track-background,
.slider-duracion ::v-deep .v-slider__track-background,
.slider-viento ::v-deep .v-slider__track-background {
  border-radius: 4px;
}

.slider-iso ::v-deep .v-slider__thumb,
.slider-duracion ::v-deep .v-slider__thumb,
.slider-viento ::v-deep .v-slider__thumb {
  background-color: var(--slider-main-color);
  border-color: var(--slider-main-color);
}

.slider-iso ::v-deep .v-slider__thumb-label,
.slider-duracion ::v-deep .v-slider__thumb-label,
.slider-viento ::v-deep .v-slider__thumb-label {
  background-color: var(--slider-main-color);
  color: #ffffff;
  font-weight: 600;
}

.slider-iso ::v-deep .v-slider__tick-label,
.slider-duracion ::v-deep .v-slider__tick-label,
.slider-viento ::v-deep .v-slider__tick-label {
  font-size: 11px;
  color: #9e9e9e;
  font-weight: 400;
}

.slider-duracion ::v-deep .v-slider__tick {
  width: 0;
  height: 0;
  background: transparent;
  border: none;
}

.slider-duracion ::v-deep .v-slider__tick-label {
  font-size: 11px;
  color: #9e9e9e !important;
  font-weight: 400;
}

.slider-viento {
  width: 100%;
}

/*CSS Ajustes avanzados*/
.ajustes-avanzados ::v-deep .v-expansion-panel-content__wrap {
  padding-left: 0;
  padding-right: 0;
}

/*CSS Meteo*/
.selector-modelo-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/*CSS Modelo combustible*/
.fila-modelos-combustible {
  align-items: center;
}

.select-modelo .v-input {
  margin-top: 0;
  margin-bottom: 0;
}

.select-modelo .v-input__control {
  min-height: 40px;
}

.texto-editar-opcion {
  display: flex;
  align-items: center;
  font-size: 0.875rem;
}

.separador-opcion {
  margin: 0 4px;
}

.btn-link-editar {
  text-transform: none;
  font-weight: 700;
  padding: 0 2px;
  min-width: 0;
}

/*CSS Footer y botones*/
.simulacion-body {
  padding-bottom: 80px;
}

.sim-footer-fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  padding: 8px 16px 10px;
  background-color: #ffffff;
  box-shadow: 0 -1px 4px rgba(0, 0, 0, 0.15);
  z-index: 2000;
}

.btn-footer-reset,
.btn-footer-simular {
  flex: 1 1 0;
  width: 50%;
  border-radius: 9999px;
  text-transform: uppercase;
  font-weight: 500;
  font-size: 0.8rem;
  min-height: 34px;
  padding: 0 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn-footer-reset {
  border: 2px solid #f44336;
  background-color: #ffffff !important;
  color: #f44336 !important;
}

.btn-footer-simular {
  border: 2px solid #005579;
  background-color: #ffffff !important;
  color: #4caf50 !important;
}

/*CSS Snackbars*/
.snackbar-above-footer {
  bottom: 80px !important;
  z-index: 3000 !important;
}

::v-deep .fila-clicable {
  cursor: pointer;
}
</style>
